import React from 'react';
import Layout from '../layout/layout';
import ArticlePage from '../article-page/ArticlePage';
import SEO from '../../../shared/components/SEO';

const ArticleTemplate = ({ pageContext }: any) => {
    return (
        <Layout>
            <ArticlePage data={pageContext} />
        </Layout>
    );
};

export const Head = ({ pageContext, location }: any) => (
    <SEO
        title={pageContext.dataSEO?.metaTitle}
        description={pageContext.dataSEO?.metaDescription}
        index={pageContext.dataSEO?.index}
        ogImage={pageContext.dataSEO?.metaImage?.file?.url}
        pathname={location.pathname}
    />
);

export default ArticleTemplate;
